import { setError } from 'src/fetch/common';
import _ from 'lodash';

/**
 * 제출서류 목록 Result 세팅 (uppr_cat_nm 기준 그룹핑)
 */
export const submitDocDataSet = (data: any, error: any, errMsg?: string) => {
  const errorSet = setError(data, error, errMsg);
  const list = _.cloneDeep(data)?.data?.result || [];

  const groupMap: any = {};
  list.forEach((item: any) => {
    const catCd = item.uppr_cat_cd;
    const catNm = item.uppr_cat_nm;
    if (!groupMap[catCd]) {
      groupMap[catCd] = {
        uppr_cat_cd: catCd,
        uppr_cat_nm: catNm,
        list: [],
      };
    }
    groupMap[catCd].list.push({
      idx: groupMap[catCd].list.length,
      name: item.name,
      docType: item.doc_nm,
    });
  });

  const resultSet = {
    resError: errorSet,
    resData: Object.values(groupMap),
  };
  return resultSet;
};
